/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { IconWithContentCardContent } from '../Shared/IconWithContentCardContent'
import formatDate from '../../../../../helpers/formatDate'

const ImportStockCardContent = ({data}) => {
    const [t] = useTranslation()

    return (
      <IconWithContentCardContent
        iconElement={(
          <>
              <Icon color="grey" name="plug"/>
              <Icon
                corner
                name={data.state ? 'checkmark' : 'ban'}
                color={data.state ? 'green' : 'red'}
              />
          </>
        )}
        contentElement={(
          <div>
              <p
                css={css`
                    font-weight: bold;
                    margin-bottom: .5rem;
                `}>
                  {t('import_stock.stocks', {name: data?.name})}
              </p>
              {data.state?.syncAt &&
                <p>
                    {t('import_stock.state.last_sync')}<br />
                    <b>{formatDate(data.state.syncAt)}</b>
                </p>
              }
          </div>
        )}
      />
    )
}

export { ImportStockCardContent }
